import React from 'react'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const DollarSign = ({ className }) => {
  return <span className={cx(className, css.dollarSign)}>$</span>
}

DollarSign.defaultProps = {}

export default DollarSign
